import { styled } from '@mui/system';
import { useAtomValue } from 'jotai';
import { showLeadershipCardOrgState } from '../../AdminPanel/DataDisplay/DataDisplayState';
import { FinancingHistoryTable } from '../../CompanyProfiles/Summary/components/FinancingHistory/FinancingHistoryTable';
import { NewsSection } from '../../CompanyProfiles/Summary/components/NewsSection';
import { selectedCompanyIdProfileAtom } from '../../CompanyProfiles/state/UIStateJ';
import { Panel } from './Panel';
import { DigestPanel } from './DigestPanel';
import { RecentActivityPanel } from './RecentActivity/RecentActivityPanel';
import { SummaryStrongestConnections } from './SummaryStrongestConnections';
import { LeadershipPanel } from './LeadershipPanel';
import { CompanyProfilesContainerBreakpoint } from './summary-layout.styles';

const MainWrapper = styled('div')`
  container-name: company-profiles-container;
  container-type: inline-size;
  display: grid;
  height: 100%;
  width: 100%;
`;

const SummaryLayout = styled('div', { shouldForwardProp: (prop) => prop !== 'showLeadership' })<{
  showLeadership: boolean;
}>`
  display: grid;
  gap: 1rem;
  height: 100%;
  padding: 1rem;
  width: 100%;

  @container company-profiles-container (width < ${CompanyProfilesContainerBreakpoint}) {
    grid-template-columns: 1fr 0fr;
    grid-template-areas:
      'digest'
      'digest'
      'digest'
      ${({ showLeadership }) => (showLeadership ? "'leader'" : '')}
      'connections'
      'connections'
      'connections'
      'activity'
      'activity'
      'news'
      'news'
      'fin-hist'
      'fin-hist';
  }

  @container company-profiles-container (width >= ${CompanyProfilesContainerBreakpoint}) {
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      ${({ showLeadership }) =>
        showLeadership
          ? "'digest leader' 'digest connections' 'digest connections'"
          : "'digest connections' 'digest connections' 'digest connections'"}
      'news activity'
      'news activity'
      'fin-hist fin-hist'
      'fin-hist fin-hist';
  }
`;

const PanelWrapper = styled('div')`
  height: 100%;
  width: 100%;
  min-height: 160px;
`;

export function CompanySummaryDiscovery() {
  const companyId = useAtomValue(selectedCompanyIdProfileAtom);
  const showLeadership = useAtomValue(showLeadershipCardOrgState);
  return (
    <MainWrapper>
      <SummaryLayout showLeadership={showLeadership}>
        <PanelWrapper style={{ gridArea: 'digest' }}>
          <DigestPanel companyId={companyId} />
        </PanelWrapper>
        {showLeadership && (
          <PanelWrapper style={{ gridArea: 'leader' }}>
            <LeadershipPanel companyId={companyId} />
          </PanelWrapper>
        )}
        <PanelWrapper style={{ gridArea: 'connections' }}>
          <SummaryStrongestConnections />
        </PanelWrapper>
        <PanelWrapper style={{ gridArea: 'news' }}>
          <Panel title={'News'}>
            <NewsSection />
          </Panel>
        </PanelWrapper>
        <PanelWrapper style={{ gridArea: 'activity' }}>
          <RecentActivityPanel />
        </PanelWrapper>
        <PanelWrapper style={{ gridArea: 'fin-hist' }}>
          <Panel
            title={'Financing History'}
            showMore={{ url: '../financials', title: 'Go to Financials' }}
            collapsible
            defaultExpanded
          >
            <FinancingHistoryTable />
          </Panel>
        </PanelWrapper>
      </SummaryLayout>
    </MainWrapper>
  );
}
